module.exports = __webpack_public_path__ + "img/mb-zoho-1.496b1ac8.jpg";